import adjustEvents from "../json/adjust-events.json";

const IMPACT_CLICK_ID = "irclickid";

let eventMetaData = {
	client: "web",
};

function createPersonalizationTraits(userSubscription = {}) {
	try {
		return {
			personalization: {
				is_subscribed: userSubscription
					? userSubscription.is_subscribed || false
					: false,
				subscription_start_date: userSubscription
					? userSubscription.subscription_start_date || ""
					: "",
				subscription_id: userSubscription
					? userSubscription.subscription_id || ""
					: "",
				plan_tier: userSubscription
					? userSubscription.plan_tier || ""
					: "",
			},
		};
	} catch (error) {
		console.warn(error);
		return {
			personalization: {
				is_subscribed: false,
				subscription_start_date: "",
				subscription_id: "",
				plan_tier: "",
			},
		};
	}
}

function createAdTraits(adParams = {}) {
	try {
		return {
			attribution: {
				utm_source: adParams ? adParams.utm_source || "" : "",
				utm_medium: adParams ? adParams.utm_medium || "" : "",
				utm_campaign: adParams ? adParams.utm_campaign || "" : "",
				utm_content: adParams ? adParams.utm_content || "" : "",
				utm_term: adParams ? adParams.utm_term || "" : "",
			},
			ad_identifier: {
				fbp: adParams ? adParams.fbp || "" : "",
				fbc: adParams ? adParams.fbc || "" : "",
				fbclid: adParams ? adParams.fbclid || "" : "",
				gclid: adParams ? adParams.gclid || "" : "",
				msclkid: adParams ? adParams.msclkid || "" : "",
				ttclid: adParams ? adParams.ttclid || "" : "",
				rdt_cid: adParams ? adParams.rdt_cid || "" : "",
				gps_adid: "",
				idfa: "",
				idfv: "",
			},
		};
	} catch (error) {
		console.warn(error);
		return {
			attribution: {
				utm_source: "",
				utm_medium: "",
				utm_campaign: "",
				utm_content: "",
				utm_term: "",
			},
			ad_identifier: {
				fbp: "",
				fbc: "",
				fbclid: "",
				gclid: "",
				ttclid: "",
				rdt_cid: "",
				msclkid: "",
				gps_adid: "",
				idfa: "",
				idfv: "",
			},
		};
	}
}

function createUserTraits(user = {}) {
	try {
		return {
			email: user ? user.email || "" : "",
			firstName: user ? user.firstName || "" : "",
			lastName: user ? user.lastName || "" : "",
			phone: user ? user.phoneNumber || "" : "",
			city: user ? user.city || "" : "",
			address: {
				state: user ? user.state || "" : "",
				postalCode: user ? user.zip || "" : "",
				country: user ? user.country || "" : "",
			},
			externalId: user ? user.id || "" : "",
		};
	} catch (error) {
		console.warn(error);
		return {
			email: "",
			firstName: "",
			lastName: "",
			phone: "",
			city: "",
			address: {
				state: "",
				postalCode: "",
				country: "",
			},
			externalId: "",
		};
	}
}

function createTraitsPlaceholder() {
	return {
		email: "",
		firstName: "",
		lastName: "",
		phone: "",
		city: "",
		address: {
			state: "",
			postalCode: "",
			country: "",
		},
		externalId: "",
		attribution: {
			utm_source: "",
			utm_medium: "",
			utm_campaign: "",
			utm_content: "",
			utm_term: "",
		},
		ad_identifier: {
			fbp: "",
			fbc: "",
			fbclid: "",
			gclid: "",
			msclkid: "",
			ttclid: "",
			rdt_cid: "",
			gps_adid: "",
			idfa: "",
			idfv: "",
		},
		personalization: {
			is_subscribed: false,
			subscription_start_date: "",
			subscription_id: "",
			plan_tier: "",
		},
	};
}

function createAnalyticsPayload(adParams, userSubscription = null) {
	if (!adParams || typeof adParams !== "object") {
		adParams = {};
	}

	const attribution = {
		utm_source: adParams.utm_source || "",
		utm_medium: adParams.utm_medium || "",
		utm_campaign: adParams.utm_campaign || "",
		utm_content: adParams.utm_content || "",
		utm_term: adParams.utm_term || "",
	};

	const adIdentifier = {
		fbp: adParams.fbp || "",
		fbc: adParams.fbc || "",
		fbclid: adParams.fbclid || "",
		gclid: adParams.gclid || "",
		msclkid: adParams.msclkid || "",
		ttclid: adParams.ttclid || "",
		rdt_cid: adParams.rdt_cid || "",
		gps_adid: "",
		idfa: "",
		idfv: "",
	};

	return {
		context: {
			traits: {
				platform: "web",
				userId: "",
				email: "",
				firstName: "",
				lastName: "",
				phone: "",
				city: "",
				address: {
					country: "",
					postalCode: "",
					state: "",
				},
				ad_identifier: adIdentifier,
				attribution: attribution,
				personalization: {
					is_subscribed: userSubscription
						? userSubscription.is_subscribed
						: false,
					subscription_start_date: userSubscription
						? userSubscription.subscription_start_date
						: "",
					subscription_id: userSubscription
						? userSubscription.subscription_id
						: "",
					plan_tier: userSubscription
						? userSubscription.plan_tier
						: "",
				},
				ab_experiment: {
					experiment_id: "",
					variant_id: "",
					ab_test_group: "",
				},
			},
		},
		properties: {
			action_source: "website",
		},
	};
}

function getAnalyticsOptions(eventName, originalContext = {}) {
	const integrations = {
		Iterable: false,
		Optimizely: window.optimizelyEvents
			? window.optimizelyEvents.includes(eventName)
			: null,
	};

	const options = { integrations, context: originalContext };
	const urlParams = new URLSearchParams(window.location.search);

	if (urlParams.has(IMPACT_CLICK_ID)) {
		const clickId = urlParams.get(IMPACT_CLICK_ID);
		const context = {
			...originalContext,
			referrer: {
				type: "impactRadius",
				id: clickId,
			},
		};
		options.context = context;
	}

	return options;
}

function identify(id, props = {}) {
	var date = new Date();
	var timezoneArray = /\((.*)\)/.exec(date.toString());
	var timezone =
		timezoneArray && timezoneArray.length > 1 ? timezoneArray[1] : null;
	var properties = {
		app: "Growth",
		release: VERSION,
		visit_date_and_time: date.toString(),
		visit_hour: date.getHours(),
		time_zone: timezone,
		label: null,
		category: null,
		userId: id,
		...props,
	};

	if (window.analytics && typeof window.analytics.identify === "function") {
		window.analytics.identify(id, properties, getAnalyticsOptions());
	}
	if (
		window.rudderanalytics &&
		typeof window.rudderanalytics.identify === "function"
	) {
		window.rudderanalytics.identify(id, properties, getAnalyticsOptions());
	}
}

function track(event, properties, callback, context = {}) {
	var adjustLoaded = typeof window.Adjust === "object" ? true : false;
	var adblockerMessaging = adjustLoaded ? "Potential Ad Blocker" : "";
	var adjustAttribution = window.Adjust.getAttribution();
	var adjustAdid = adjustAttribution
		? adjustAttribution.adid
		: `Adjust adid not available. ${adblockerMessaging}`;
	var adjustWebUUID = window.Adjust.getWebUUID()
		? window.Adjust.getWebUUID()
		: `Adjust web_uuid not available. ${adblockerMessaging}`;

	properties = Object.assign({}, eventMetaData, properties);
	properties.adjust_adid = adjustAdid;
	properties.adjust_web_uuid = adjustWebUUID;
	properties.adjust_loaded = adjustLoaded;
	properties.web_build_version = document.getElementById("build").value;

	if (window.analytics && typeof window.analytics.track === "function") {
		window.analytics.track(
			event,
			properties,
			getAnalyticsOptions(event, context),
			callback
		);
	}

	trackAdjustEvent(event);
}

function trackAdjustEvent(event, email, userId, currency, transactionValue) {
	const adjustEventName = event.replace(/\s-\s|\s/g, "-").toLowerCase();
	const eventToken = adjustEvents[adjustEventName];

	if (
		(typeof window.Adjust !== "object" &&
			typeof window.Adjust.trackEvent !== "function") ||
		!eventToken
	)
		return;

	if (transactionValue) {
		window.Adjust.addGlobalCallbackParameters([
			{ key: "currency", value: currency },
			{ key: "transaction_value", value: transactionValue },
		]);
	} else if (email && userId) {
		window.Adjust.addGlobalCallbackParameters([
			{ key: "email", value: email },
			{ key: "user_id", value: userId },
		]);
	}

	if (currency) {
		window.Adjust.trackEvent({
			eventToken,
			currency,
		});
	} else {
		window.Adjust.trackEvent({ eventToken });
	}
}

function trackSuccessfulRegistration(
	optimizelyId,
	properties,
	email,
	userId,
	callback,
	context
) {
	var event = "Account Registration - Successful";
	var adjustLoaded = typeof window.Adjust === "object" ? true : false;
	var adblockerMessaging = adjustLoaded ? "Potential Ad Blocker" : "";
	var adjustAttribution = window.Adjust.getAttribution();
	var adjustAdid = adjustAttribution
		? adjustAttribution.adid
		: `Adjust adid not available. ${adblockerMessaging}`;
	var adjustWebUUID = window.Adjust.getWebUUID()
		? window.Adjust.getWebUUID()
		: `Adjust web_uuid not available. ${adblockerMessaging}`;

	properties = Object.assign({}, eventMetaData, properties);
	properties.adjust_adid = adjustAdid;
	properties.adjust_web_uuid = adjustWebUUID;
	properties.adjust_loaded = adjustLoaded;
	properties.web_build_version = document.getElementById("build").value;

	if (
		optimizelyId &&
		window.optimizelyClientInstance &&
		typeof window.optimizelyClientInstance.track === "function"
	) {
		window.optimizelyClientInstance.track(
			event,
			optimizelyId,
			{},
			properties
		);
	}

	if (window.analytics && typeof window.analytics.track === "function") {
		window.analytics.track(
			event,
			properties,
			getAnalyticsOptions(event, context),
			callback
		);
	}

	trackAdjustEvent(event, email, userId);

	// Track account creation via Live Intent Pixel
	window.liQ = window.liQ || [];
	window.liQ.push({
		event: "signup",
		email: email,
		conversionId: userId,
	});

	// Track account creation via Bing Ads
	window.uetq = window.uetq || [];
	window.uetq.push("event", "Account Registration", {
		event_category: "sign up",
		event_label: "successful submission",
	});

	// Track account creation via Pinterest Tag
	pintrk("track", "Signup");
}

function trackSuccessfulTrialSignup(optimizelyId, properties, callback) {
	var event = "Web Account Registration - Trial Activated";
	var adjustLoaded = typeof window.Adjust === "object" ? true : false;
	var adblockerMessaging = adjustLoaded ? "Potential Ad Blocker" : "";
	var adjustAttribution = window.Adjust.getAttribution();
	var adjustAdid = adjustAttribution
		? adjustAttribution.adid
		: `Adjust adid not available. ${adblockerMessaging}`;
	var adjustWebUUID = window.Adjust.getWebUUID()
		? window.Adjust.getWebUUID()
		: `Adjust web_uuid not available. ${adblockerMessaging}`;

	properties = Object.assign({}, eventMetaData, properties);
	var transactionValue = parseInt(properties.transaction_value, 10) / 100;

	properties.adjust_adid = adjustAdid;
	properties.adjust_web_uuid = adjustWebUUID;
	properties.adjust_loaded = adjustLoaded;
	properties.web_build_version = document.getElementById("build").value;
	properties.revenue = properties.transaction_value; // Params for Bing Ads

	if (
		optimizelyId &&
		window.optimizelyClientInstance &&
		typeof window.optimizelyClientInstance.track === "function"
	) {
		window.optimizelyClientInstance.track(
			event,
			optimizelyId,
			{},
			properties
		);
	}

	trackAdjustEvent(
		event,
		null,
		null,
		properties.currency,
		transactionValue.toString()
	);
	if (window.analytics && typeof window.analytics.track === "function") {
		window.analytics.track(
			event,
			properties,
			getAnalyticsOptions(event),
			callback
		);
	}

	// Track trial signup/payment submission via Bing Ads
	window.uetq = window.uetq || [];
	window.uetq.push("event", "Completed Registration", {
		event_category: "Registration",
		event_label: "Registration",
		event_value: "1",
	});

	// Track trial signup/payment submission via Pinterest Tag
	pintrk("track", "Checkout");
}

function trackLink(element, event, properties, useOldEventMetaData) {
	var metaData = useOldEventMetaData
		? {
			app: "Growth",
			release: VERSION,
		}
		: eventMetaData;
	var adjustLoaded = typeof window.Adjust === "object" ? true : false;
	var adblockerMessaging = adjustLoaded ? "Potential Ad Blocker" : "";
	var adjustAttribution = window.Adjust.getAttribution();
	var adjustAdid = adjustAttribution
		? adjustAttribution.adid
		: `Adjust adid not available. ${adblockerMessaging}`;
	var adjustWebUUID = window.Adjust.getWebUUID()
		? window.Adjust.getWebUUID()
		: `Adjust web_uuid not available. ${adblockerMessaging}`;

	properties = Object.assign({}, metaData, properties);
	properties.adjust_adid = adjustAdid;
	properties.adjust_web_uuid = adjustWebUUID;
	properties.adjust_loaded = adjustLoaded;
	properties.web_build_version = document.getElementById("build").value;
	if (window.analytics && typeof window.analytics.trackLink === "function") {
		window.analytics.trackLink(
			element,
			event,
			properties,
			getAnalyticsOptions(event)
		);
	}
}

export {
	eventMetaData,
	getAnalyticsOptions,
	identify,
	track,
	trackAdjustEvent,
	trackSuccessfulRegistration,
	trackSuccessfulTrialSignup,
	trackLink,
	createAnalyticsPayload,
	createPersonalizationTraits,
	createAdTraits,
	createUserTraits,
	createTraitsPlaceholder,
};
